var isRTL = ($('html').attr('dir') == "rtl") ? true : false,
	isHome = ($('body').hasClass('is-Homepage')) ? true : false,
	headerHeight = $('.c-main-header').outerHeight(),
	footerHeight = $('.c-main-footer').outerHeight(),
	bodyHeight,
	hamPosition,
	mobileDate,
	mobileDateValue;

/* FIREBASE Start */
var siteProtocol = window.location.protocol + '//';
var siteHost = window.location.host + '/';
var siteAssetURL = assetsUrl+'/img/placeholders/';
var imgAssetURL = assetsUrl+'/img';
var eventURL = '/event/';
var EventId;
var recordPerPage = 6;


// Loading Animation
setTimeout(function() {
    setTimeout(function() {
        $("#LoadingBar").stop().animate({
            width: "70%"
        }, 100), setTimeout(function() {
            $("#LoadingBar").stop().animate({
                width: "90%"
            }, 100)
        }, 100)
    }, 100)
}, 100);

$(function () {

    $("body").find("a").each(function () {
        var urlString = $(this).attr('href');
        if (urlString != undefined && urlString != null) {
            if (urlString.indexOf('http://') === 0 || urlString.indexOf('https://') === 0) {
                if (urlString.indexOf('javascript') === -1) {
                    $(this).attr("target", "_blank");
                }
            }
        }
    });

	winDimensions();
	loadPath();
	actionsOnClick();
	initPopup();
	tabs();
	eventFilter();
	tabs();
	//bookingForm();
	initSelect2('.js-select');
	
	menuOpen();
	menuclose();
	scrollToSec('.js-scroll-anchor', '.js-scroll-sec');
	dataTrim();
	initDatePicker();
});

//On Window Load
$(window).on('load', function () {
    doOnLoad();
});
var addPageLoadClassInterval;
var onLoadLoaded = false;
function doOnLoad() {
	if(onLoadLoaded == false){
		onLoadLoaded = true;
		addThisReadyBind();
		dataTrim();
		//changeLanguage();
		infoSectionBg();
		onTopCheck();
		customScrollBar();
		setTimeout(function () {
			addVideoPlugin();
		}, 200);
		if(winWidth <= 767){
			mobileCaroInit('.mobileCaro');
		} else {
			$('.mobileCaro.slick-initialized').slick('unslick');
		}
		fixedToScroll();
		scroll();
		// Loading Wrapper FadeOut
		setTimeout(function() {
			dataTrim();
			initSlick();
			resizeslickInit();
			ChangeToSvg();
			maxHeightSelectors();
			$("#LoadingBar").animate({width:"100%"},100);
			setTimeout(function() {
				addAddThis();
			}, 100);
		}, 200);
	}

	dataTrim();
	setTimeout(function() {
		maxHeightSelectors();

	}, 200);
	calcBodyarea();
	historyHeight();
	addBodyheight();
	addScreenheight();
    if($('.isIE').get(0)){
        $('body').addClass('page-loaded');
    }else{
        addPageLoadClassInterval = setInterval(function(){
            addPageLoadClass();
        }, 500);
    }
}
function addPageLoadClass() {
    if($('body').hasClass('css-loaded')){
        $('body').addClass('page-loaded');
        clearInterval(addPageLoadClassInterval);
    }
}

//From: http://stackoverflow.com/questions/3066586/get-string-in-yyyymmdd-format-from-js-date-object
Date.prototype.toInputFormat = function() {
   var yyyy = this.getFullYear().toString();
   var mm = (this.getMonth()+1).toString(); // getMonth() is zero-based
   var dd  = this.getDate().toString();
   return yyyy + "-" + (mm[1]?mm:"0"+mm[0]) + "-" + (dd[1]?dd:"0"+dd[0]); // padding
};

//Ready
$(document).ready(function() {
	eventWidthSet();
});

//On Window Resize
$(window).on('resize orientationchange', function () {
	if(winWidth != $(window).width()){
		winDimensions();
		calcBodyarea();
		eventWidthSet();
	 	infoSectionBg();
	 	onTopCheck();
		addBodyheight();
		setTimeout(function() {
			maxHeightSelectors();
			addScreenheight();
		}, 200);
	}
	setTimeout(function() {
		reInitSlick();
		resizeslickInit();
		historyHeight();
		fixedToScroll();
	},100);
	if(winWidth <= 767){
		mobileCaroInit('.mobileCaro');
	} else {
		$('.mobileCaro.slick-initialized').slick('unslick');
	}
});

//On Scroll
$(window).on('scroll', function (){
	onTopCheck()
});

//Escape Functionality
$(document).keyup(function(e) {
    if (e.keyCode == 27) {
    	$('.js-langSelector').find('ul').removeClass('active');
    	$('.menu-sec').removeClass('is--active');
		$('body, html').removeClass('menu-open');
		$('.js-childDropdown').removeClass('active');
    }
});

//CLick on body
$(document).on('click touchstart', function (e) {
	if ($(e.target).closest('.js-langSelector').length === 0) {
		$('.js-langSelector').find('ul').removeClass('active');
	}
	if ($(e.target).closest('.filterItem.hasDropdown, .filterItem.hasDropdown> *, .js-childDropdown > *, .ui-corner-all').length === 0) {
		 $('.js-childDropdown').removeClass('active');
	}
});

$(document).on('click', '.menu-sec.is--active', function(e) {
	if ($(e.target).closest('.menu-inner, .main-nav').length === 0) {
		$('.menu-sec .close-menu').click();
	}
})

// Fade Body before Switching page
$('a').click(function(e) {
	//e.preventDefault();
	var diffLoc = false;
	var locHash = false;
	var loc = $(e.currentTarget).attr('href');
	diffLoc = ($(e.currentTarget).attr('target') == undefined || $(e.currentTarget).attr('target') == "");
	locHash = ($(e.currentTarget).attr('href').split('#')[0] == "") || ($(e.currentTarget).attr('href').split('tel:')[0] == "") || ($(e.currentTarget).attr('href').split('mailto:')[0] == "")  || ($(e.currentTarget).attr('href').split('javascript')[0] == "");


	if (window.location.href === loc || loc === 'javascript:void(0);' || locHash || !diffLoc) {

	}
	else{
		e.preventDefault();
		if (e.ctrlKey) {
			window.open(loc);
		}
		else{
			$('body').fadeOut();
			setTimeout(function() {
				window.location.href = loc;
			}, 400);
		}
	}
});

function winDimensions() {
	winWidth = $(window).width(),
	winHeight = $(window).height(),
	headerHeight = $('.c-main-header').outerHeight(),
	footerHeight = $('.c-main-footer').outerHeight();
}

showPassword();
function showPassword() {
	$('.js-showPassword').click(function() {

		var x = ($(this).parent('.control-group').find('#formPassword'));
	    if (x.attr('type') === 'password') {
	    	x[0].setAttribute('type', 'text')
	    	$(this).text("Hide password");
	    } else {
	    	x[0].setAttribute('type', 'password')
	    	$(this).text("Show password");
	    }
	})
}
function winDimensions() {
	winWidth = $(window).width(),
	winHeight = $(window).height(),
	headerHeight = $('.c-main-header').outerHeight(),
	footerHeight = $('.c-main-footer').outerHeight();
}
ChangeToBg();
function ChangeToBg() {
	if($('html').hasClass('no-objectfit', 'no-object-fit')){
		$('img.js-imagefit').each(function () {
		    var $img = $(this);
		    var imgID = $img.attr('id');
		    var imgClass = $img.attr('class');
		    var imgURL = $img.attr('src');
		    var bgDIv = $img.parents('div')[0];
		    $(bgDIv).css("background-image","url(../"+ imgURL +")");
		    $(bgDIv).addClass('js-imagefitparent');
		});
	}
}


function loadPath() {
    var currentLoc = window.location.pathname;
    $('.secondary-nav a[href="' + currentLoc + '"]').addClass('active');
    $('.bold-links ul li a[href="' + currentLoc + '"]').addClass('active');
    $('.nor-links ul li a[href="' + currentLoc + '"]').addClass('active');
}
function actionsOnClick() {
	$('.js-langSelector').on('click', function(e){
		e.preventDefault();
		$(this).find('ul').toggleClass('active');
	});
	$('.js-datelinerDropdown').on('click', function(e){
		e.preventDefault();
		$(this).siblings('.dropdownBox').slideToggle();
	});
	$('.hasDropdown a').on('click', function(e){
		e.preventDefault();
		$(this).siblings('.js-childDropdown').toggleClass('active');
		//$(this).parent().toggleClass('active');
	});
}
function initDatePicker(argument) {

	if (isRTL) {
		monthnamelabel = ['يناير','فبراير ','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر	'];
	} else {
		monthnamelabel = ['January','February','March','April','May','June','July','August','September','October','November','December'];
	}

	$( ".c-datepicker" ).each(function () {
		$( this ).datepicker({
			dayNamesMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
			minDate: 0,
			monthNames: monthnamelabel,
			// maxDate: "+4M",			
			onSelect: function(dateText, inst) {
				var currentDate = new Date();
		        var date = $(this).val();
		        filterByValue = 'day';
		        $('.js-childDropdown.active', this).removeClass('active');
		        $('.c-collapseable').removeClass('showing');
		        $('.accordion-content').slideUp('slow');
		        var selectDate = new Date(date);
		        showDays(selectDate,currentDate);
		        $('.js-date').attr('data-filter-start-date',selectDate.toInputFormat());
		        $('.js-date').attr('data-filter-end-date',selectDate.toInputFormat());
		        $('.js-day').attr('data-filter-start-date',selectDate.toInputFormat());
	        	$('.js-day').attr('data-filter-end-date',selectDate.toInputFormat());
		        $('.js-date').parent().addClass('active');	        
		        $('.js-childDropdown').removeClass('active');
		        $('.js-filter-label').html(weekday[selectDate.getDay()]);
		        var filterDateValue = $.datepicker.formatDate('dd M yy', new Date(selectDate));	
				filterDateValue = arabicDateCheck(filterDateValue);	
				$('.js-filter-value').html(filterDateValue);	        
		        mobileDate =1;    
		        mobileDateValue = selectDate.toInputFormat();    
		        getDataCalenderMain();
		        setTimeout(function() {
					dataTrim();
					ChangeToSvg();
				}, 600);
		    }
		});
	})
}
function calcBodyarea() {
	bodyHeight = winHeight - headerHeight - footerHeight;
	$('.js-page-body').css('min-height', bodyHeight)
}
function eventWidthSet() {

	eventBoxWidth = $('.event--cell').width();
	$('.top-img img').css('width', eventBoxWidth)
}
function menuOpen() {
	$( ".hamburger a" ).each(function(index) {
		$(this).on("click", function(e){
			e.preventDefault();
			hamPosition = $(this)[0].getBoundingClientRect();
			$('.close-menu').css({
				'left': hamPosition.left,
				'top': hamPosition.top,
			})
			$('.menu-sec').addClass('is--active');
			setTimeout(function() {
				$('body, html').addClass('menu-open');
			},100);
			if (winWidth < 992) {
				var posTop = '-' + $(window).scrollTop();
				$('html').css({
					'position': 'fixed',
					'top': posTop+'px',
				})
			}
		});
	});
}
function menuclose() {
	$('.close-menu').on('click', function(e){
		e.preventDefault();
		$('.menu-sec').removeClass('is--active');
		setTimeout(function() {
			$('body, html').removeClass('menu-open');
		},100);
		if (winWidth < 992) {
			var topPos = $('html').css('top');
			if (topPos != "0px") {
				var makInt = topPos.split('-')[1].split('px')[0];				
			}
			$('html').css({
				'position': 'relative',
				'top': 'auto',
			});
			$(window).scrollTop(parseInt(makInt));
		}
	});
}
function reInitSlick() {
	if ($('.slick-initialized').length > 0) {
		$('.slick-initialized').each(function() {
			$(this).slick('setPosition');
		})
	}
}
function initSlick() {
	if (isRTL) {
		var bannerPrev = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-right.svg" alt="caret-left" class="toSvg js-inline-svg svgBlack" /></button>'
		var bannerNext = '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-left.svg" alt="caret-right" class="toSvg js-inline-svg svgBlack" /></button>'
		if (isHome) {
			bannerPrev = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-right.svg" alt="caret-left" class="toSvg js-inline-svg svgBlack" /></button>'
			bannerNext = '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-left.svg" alt="caret-right" class="toSvg js-inline-svg svgBlack" /></button>'
		}

	} else {
		var bannerPrev = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-left.svg" alt="caret-left" class="toSvg js-inline-svg svgBlack" /></button>'
		var bannerNext = '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-right.svg" alt="caret-right" class="toSvg js-inline-svg svgBlack" /></button>'
		if (isHome) {
			bannerPrev = '<button class="slick-prev slick-arrow" aria-label="Previous" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-left.svg" alt="caret-left" class="toSvg js-inline-svg svgBlack" /></button>'
			bannerNext = '<button class="slick-next slick-arrow" aria-label="Next" type="button" style=""><img src="'+imgAssetURL+'/icons/angle-right.svg" alt="caret-right" class="toSvg js-inline-svg svgBlack" /></button>'
		}
	}

	$('.js-customScrollWrapper').slick({
		autoplay: false,
		variableWidth: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		infinite: false,
		arrows: false,
		focusOnSelect: true,
		rtl: isRTL,
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
			}
		}],
	});
	//console.log(bannerPrev);
	$('.js-eventsCarousel').slick({
		autoplay: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: false,
		arrows: true,
		fade: false,
		infinite: false,
		centerMode: false,
		centerPadding: '0',
		rtl: isRTL,
		appendArrows: '.eventsCarouselNav',
		prevArrow: bannerPrev,
		nextArrow: bannerNext,
		responsive: [{
			breakpoint: 992,
			settings: {
				slidesToShow: 2,
			}
		},
		{
			breakpoint: 768,
			settings: {
				slidesToShow: 1,
				arrows: false,
			}
		}],
	});
	$('.js-captionSlider').slick({
		autoplay: true,
		autoplaySpeed: 5000,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		fade: false,
		draggable: true,
		infinite: true,
		rtl: isRTL,
		appendArrows: '.js-transparent-btn',
        asNavFor: '.js-figureSlider,js-figureCaptionSlider',
		appendDots: '.js-slideNumber',
		customPaging: function (slider, i) {
			if (i < 9) {
				return  '0' + (i + 1) + '<small> / 0' + slider.slideCount + '</small>';
			}else{
				return  '' + (i + 1);
			}
		},
	});

	$('.js-captionSlider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
		$(this).parent().find('.bricks .slide').removeClass('is--active');
		$(this).parent().find('.bricks .slide:nth-child('+ (nextSlide+1) +')').addClass('is--active');
	});
	
	
	$('.js-figureSlider').slick({
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplaySpeed: 5000,
		speed: 1000,
		dots: false,
		arrows: true,
		fade: true,
		infinite: true,
		rtl: isRTL,
		appendArrows: '.js-transparent-btn-slide',
		asNavFor: '.js-captionSlider, .js-figureCaptionSlider',
	});
	$('.js-figureCaptionSlider').slick({
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		fade: false,
        draggable: false,
        infinite: true,
		rtl: isRTL,
		asNavFor: '.js-captionSlider, .js-figureSlider',
	});

	$('.js-infoSliderImg').slick({
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		fade: true,
		draggable: true,
		infinite: false,
		rtl: isRTL,
		asNavFor: '.js-infoSliderConent',
		prevArrow: bannerPrev,
		nextArrow: bannerNext,
		appendArrows: '.js-infoSliderNav',
		appendDots: '.js-slideNumber',
		customPaging: function (slider, i) {
			if (i < 9) {
				return  '0' + (i + 1) + '<small> / 0' + slider.slideCount + '</small>';
			}else{
				return  '' + (i + 1);
			}
		},
	});
	$('.js-infoSliderConent').slick({
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		fade: false,
		draggable: true,
		infinite: false,
		rtl: isRTL,
		asNavFor: '.js-infoSliderImg',
	});

	$('.js-timeline2-links-carousel').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		swipeToSlide: true,
		focusOnSelect: true,
		adaptiveHeight: false,
		rtl: isRTL,
	});

	$('.js-timeline2-links-carousel a').click(function(e) {
		e.preventDefault();
	});

	$('.js-timeline2-links-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		tabLinkClick($('.js-timeline2-links-carousel .slick-slide[data-slick-index="'+nextSlide+'"] a')[0]);
	});

	$('.js-timeline2-carousel').each(function () {
		$(this).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			infinite: false,
			swipeToSlide: true,
			focusOnSelect: true,
			rtl: isRTL,
			prevArrow: bannerPrev,
			nextArrow: bannerNext,
			appendArrows: $(this).parent().find('.js-timeline2-carousel-arrows')
		});
	});

	$('.js-timeline2-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
		$('.js-timeline2-links-carousel .slick-active .in-year-bullets span').removeClass('is--active');
		$('.js-timeline2-links-carousel .slick-active .in-year-bullets span:nth-child('+(nextSlide+1) +')').addClass('is--active');
	});
	$('.js-timeline2-links-carousel .in-year-bullets span:nth-child('+ 1 +')').addClass('is--active');


	$('.js-timline2-item-close').click(function (e) {
		e.preventDefault();
		$('.timeline2-popover .content-item').removeClass('is--active');
		$('.timeline2-popover').removeClass('is--active');
	});
	$('.js-timline2-select').click(function (e) {
		e.preventDefault();

		$('.timeline2-popover').addClass('is--active');
		var target = $(this).attr('href');
		$('.timeline2-content .content-item').removeClass('is--active');
		$(target).addClass('is--active');
	});
	$('.js-detailSlider').slick({
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: false,
		arrows: false,
		fade: false,
		draggable: false,
		infinite: false,
		rtl: isRTL,
	});
	$('.js-image-slider').slick({
		autoplay: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		fade: true,
		draggable: true,
		infinite: false,
		rtl: isRTL,
		appendDots: '.js-ImageSliderIndicator',
		appendArrows: '.js-ImageSliderNav',
		prevArrow: bannerPrev,
		nextArrow: bannerNext,
		customPaging: function (slider, i) {
			var currentSlideLabel = "0";
			var totalSlidesLabel = "0";
			if(i > 8){
				currentSlideLabel = "";
			}
			if(slider.slideCount > 8){
				totalSlidesLabel = "";
			}
			return  currentSlideLabel + (i + 1) + '<small> / '+totalSlidesLabel + slider.slideCount + '</small>';
		},
	});
}
function resizeslickInit() {
	if(winWidth < 768){
		$('.js-mb-eventsCarousel > .c-row').slick({
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			fade: false,
			infinite: false,
			centerMode: false,
			centerPadding: '0',
			rtl: isRTL,
		});
	}else{
		$('.js-mb-eventsCarousel > .c-row.slick-initialized').slick('unslick');
	}
}

	var offsetMainContiner = 0;
	var offsetSpan = 0;
	var topDiffrence = 0
	var imageDimW = 0
	var imageDimH = 0

//info Section 
function infoSectionBg() {
	setTimeout(function(){ 
		$('.sectionpixel, .slideFg span i').removeAttr('style');
		offsetMainContiner = $('.sectionpixel').offset(),
		imageDimW = $('.slideBg:first').outerWidth();
		imageDimH = $('.slideBg:first').outerHeight();
		if(winWidth > 1199){
			$('.sectionpixel').css({
				'min-height': winHeight,
				'width': winWidth,
			})
		} else {
			$('.sectionpixel').removeAttr('style')
		}
		$('.slideFg span i').each(function() {
		     offsetSpan = $(this).offset();
		     topDiffrence = offsetMainContiner.top - offsetSpan.top;
		     $(this).css({
				'height': winHeight,
				'width': winWidth,
			    'left': -offsetSpan.left,
			    'top': topDiffrence,
		     })
		});
		$('.slideFg, .slideBoxes').css({
			'height': imageDimH,
			'width': imageDimW,
		})
	}, 100);
}
function openPopup(target) {
	$('html').addClass('popup-is-active');
	$(target).show();
	$(target).closest('.c-popup').show();
	setTimeout(function(){
		$(target).addClass('active');
		$(target).closest('.c-popup').addClass('popup--open');
		if($(target).find('.plyr').length){
			var videoInstance = $(target).find('.plyr').attr('data-video-instance');
			players[videoInstance].play();
		}
	}, 10);
	$('html').addClass('popup-is-active');
	$(target).show();
	$(target).closest('.c-popup').show();
	setTimeout(function(){
		$(target).addClass('active');
		$(target).closest('.c-popup').addClass('popup--open');

		// Play Video
		if(winWidth > 1024 && $(target).find('.plyr').length){
			var videoInstance = $(target).find('.js-video').attr('data-video-instance');
			if(players[videoInstance]){
				players[videoInstance].play();
			}
		}else if($(target).find('.js-video').length){
			$('.popup.active iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
		}

	}, 10);
}
function closePopup() {
	if($('.c-popup .active').length){
		// Pause Video In Popup
		if(winWidth > 1024 && $('.c-popup .active .plyr').length){
			var videoInstance = $('.c-popup .active .plyr').attr('data-video-instance');
			if(players[videoInstance]){
				players[videoInstance].pause();
			}
		}else if($('.c-popup .active .js-video').length){
			$('.popup.active iframe')[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		}

		// Close Popup
		$('.c-popup .active').removeClass('active');
		$('.c-popup').removeClass('popup--open');
		setTimeout(function () {
			$('.c-popup .popup').hide();
			$('.c-popup').hide();
			$('html').removeClass('popup-is-active');
		}, 310);
	}
}
function addAddThis() {
	if(typeof loadAddThis !== 'undefined'){
		var addThisElement = document.createElement("script");
		addThisElement.setAttribute('src', '//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5bf58d854d9d4a39');
		addThisElement.setAttribute('async', 'true');
		document.body.appendChild(addThisElement);
		/*$(window).scroll(function() {
			var winScroll = $(this).scrollTop();
			if (winScroll > 0) {
				$('body').addClass('scroll--not-on-top');
			} else{
				$('body').removeClass('scroll--not-on-top');
			}
		});*/
	}
}
function addVideoPlugin() {
	if((winWidth > 1024 && $('.js-video').get(0)) && !$('html').hasClass('isIE')){
		var plyrScriptElement = document.createElement("script");
		if (isRTL) {
			plyrScriptElement.setAttribute('src', assetsUrl+'/js/plyr.min.js');	
			if (isHome) {
				plyrScriptElement.setAttribute('src', assetsUrl+'/js/plyr.min.js');	
			}
		} else {
			plyrScriptElement.setAttribute('src', assetsUrl+'/js/plyr.min.js');
			if (isHome) {
				plyrScriptElement.setAttribute('src', assetsUrl+'/js/plyr.min.js');	
			}
		}

		plyrScriptElement.setAttribute('async', 'true');
		document.body.appendChild(plyrScriptElement);
	}else{
		jsVideoDirect();
	}
}
var players = [];
function jsVideo() {
	// Custom player
	if($('.js-video').length){
		$('.js-video').each(function(i) {
			var thisParent = $(this).parent();
			players[i] = new Plyr(this, {
				playsinline: true,
			});
			thisParent.find('.plyr').attr('data-video-instance', i);
		});
	}
}
function jsVideoDirect() {
	if($('.js-video').length){
		$('.js-video').each(function(i) {
			$(this).attr('data-video-instance', i);
			var videoId = $(this).attr('data-plyr-embed-id');
			$(this).html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+videoId+'?rel=0&playsinline=1&enablejsapi=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
		});
	}
}
function initPopup() {
	// Popup
	$('.js-popup-link').click(function (e) {
		e.preventDefault();
		var target = $(this).attr('href');
		openPopup(target);
		if ($(this).hasClass('is--gallery')) {
			$(target).find('.js-gallery').slick({
				slidesToShow: 1,
  				slidesToScroll: 1,
				arrows: true,
				infinite: false,
			    dots: true,
			    dotsClass: 'custom_paging',
			    customPaging: function (slider, i) {
			        return  (i + 1) + ' / ' + slider.slideCount;
			    }
			});
		}
	});

	$('.js-close-popup').click(function (e) {
		e.preventDefault();
		closePopup();
	});
}
// Abid IntlInput From QAH

var utilsPath;
// Tanzeel 
if (isRTL) {
	utilsPath = '/assets/js/utils.js';	
	if (isHome) {
		utilsPath = '../assets/js/utils.js';	
	}
} else {
	utilsPath = '../assets/js/utils.js';
	if (isHome) {
		utilsPath = 'assets/js/utils.js';
	}
}
$(".js-byphone").intlTelInput({
	allowDropdown: true,
	dropdownContainer: "body",
	utilsScript: utilsPath,
	separateDialCode: true,
	rtl: true,
	initialCountry: "auto",
	  	geoIpLookup: function(callback) {
	    	$.get('https://ipinfo.io', function() {}, "jsonp").always(function(resp) {
	      	var countryCode = (resp && resp.country) ? resp.country : "";
	      	callback(countryCode);
	    });
	},
});

function customScrollBar() {
	if ($('.js-custom-scroll-bar').length > 0) {
		$('.js-custom-scroll-bar').mCustomScrollbar();
	}
	$('.c-event-banner .event-txt-box .time').mCustomScrollbar({
	    theme:"minimal-dark",
	    // setHeight: 150,
	});
}
function eventFilter() {
	$('.js-event-filter-link a').click(function() {
		var eventTar = $(this).data('event-target');
		$('.js-event-filter').removeClass('is--active');
		$('.js-event-filter-link a').parent('li').removeClass('is--active')
		$(this).parent().addClass('is--active')
		$('.js-event-filter[data-event-name="'+eventTar+'"]').addClass('is--active');
		$('.js-event-filter[data-event-name="'+eventTar+'"] .js-event-filter-slider').slick('setPosition');
	});
}
function eventFilterSlider(target) {
    var target = $(target);
    var btnTarget = target.siblings('.js-slickIndicator');

    $(target).on('init', function (event, slick) {
        curSlide = slick.currentSlide + 1;
        totalSlide = slick.slideCount;
        getPrecentage = (curSlide / totalSlide) * 100;
        if (totalSlide > 1) {
            $(btnTarget).find('.js-slick-progress').find('span').width(getPrecentage + '%');
        } else {
            $(btnTarget).find('.js-slick-progress').hide();
        }
        setTimeout(function () {
            if ($('.js-event-filter-slider').get(0)) {
                $('.js-event-filter-slider').slick('slickGoTo', 1);
            }
        }, 500);
    });
    $(target).slick({
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        fade: false,
        draggable: true,
        infinite: false,
        rtl: isRTL,
        centerMode: true,
        centerPadding: '0px',
        focusOnSelect: true,
        appendDots: btnTarget,
        customPaging: function (slider, i) {
            var currentSlideLabel = "0";
            var totalSlidesLabel = "0";
            if (i > 8) {
                currentSlideLabel = "";
            }
            if (slider.slideCount > 8) {
                totalSlidesLabel = "";
            }
            return '<small>' + currentSlideLabel + (i + 1) + '</small><small>' + totalSlidesLabel + slider.slideCount + '</small>';
        },
    });
    $(target).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        curSlide = nextSlide + 1;
        totalSlide = slick.slideCount;
        getPrecentage = (curSlide / totalSlide) * 100;
        $(btnTarget).find('.js-slick-progress').find('span').width(getPrecentage + '%');
		$(btnTarget).find('.js-slick-progress').show();
    });
}


$('.js-event-filter-slider').each(function() {
	eventFilterSlider($(this));
});
var tabsFlag = 0;
function tabs() {
	$('.js-tab-link').each(function () {
		var element = this;
		element.addEventListener("mousedown", function(){
		    tabsFlag = 0;
		}, false);
		element.addEventListener("mousemove", function(){
		    tabsFlag = 1;
		}, false);
		element.addEventListener("mouseup", onMouseUp, false);
		function onMouseUp(e){
			e.preventDefault();

		    if(tabsFlag === 0){
		    	tabLinkClick(this);
		    }
		    else if(tabsFlag === 1){
		    }
		}
	});

	$('.js-tab-link').click(function (e) {
		e.preventDefault();
		// tabLinkClick(this);
	});
}
function tabLinkClick(thisLink) {
	if($(thisLink).closest('.js-timeline2-links-carousel').get(0)){
		var thisSlideInedx = $(thisLink).closest('.slick-slide').attr('data-slick-index');
		setTimeout(function () {
			$('.js-timeline2-links-carousel').slick('slickGoTo', thisSlideInedx);
		}, 460);
	}

	var target = $(thisLink).attr('href');

	$(thisLink).closest('.js-tab-link-wrap').find('.js-tab-link').removeClass('is--active');
	$(target).closest('.js-tab-content-wrap').find('.js-tab-content').removeClass('is--active');

	$(thisLink).addClass('is--active');
	$(target).addClass('is--active');
}
function onTopCheck() {
	if ($(window).scrollTop() > 300) {
		$('body').addClass('is--not-on-top');
	} else {
		$('body').removeClass('is--not-on-top');
	}

}
if($('.page-event').length) {
	$('.c-main-header').addClass('c--white-Nav');
}

function onSubmit(token) {
	var subscribeForm = $('#mc-embedded-subscribe-form');
	subscribeForm.submit();
}
function initSelect2(target) {
	var selectPlaceholder = "Select an option";
	if (isRTL) {
		selectPlaceholder = "حدد اختيارا"
	}
	$(target).each(function() {
		$(this).select2({		 
			placeholder: selectPlaceholder,
			minimumResultsForSearch: Infinity,
		});
	});
}

$('.js-tootltip').tooltip({
  	position: {
    my: "center bottom-20",
    at: "center top",
	    using: function( position, feedback ) {
	      $( this ).css( position );
	      $( "<div>" )
	        .addClass( "arrow" )
	        .addClass( feedback.vertical )
	        .addClass( feedback.horizontal )
	        .appendTo( this );
	    }
  	}
});
$( ".c-collapseable" ).click(function(e) {
	if (winWidth < 768) {
		var attribute = $(this).attr("data-accordion");
		var revert = $(this).attr("data-revert");
		e.preventDefault();
		if (revert) {
			$('[data-accordion], .c-collapseable').not(this).removeClass('showing');
			$('.ContentBox, .accordion-content').not(attribute).slideUp('slow');
		}
		if (!attribute) { // if collapse doesn't have attribute
			$(this).toggleClass('showing');
			$(this).siblings(".ContentBox").slideToggle( "slow");
		}
		else{
			$(this).toggleClass('showing');
			$(attribute).slideToggle( "slow");
		}
	}
});

function mobileCaroInit(nametarget){
	$(nametarget).slick({
		slidesToShow: 2,
		slidesToScroll: 1,
		arrows: false,
		infinite: false,
		swipeToSlide: true,
        focusOnSelect: true,
        rtl: isRTL,
	});
}
function addBodyheight() {
	$('.c-event-banner').css(
		'min-height', winHeight
	) 
}
function scrollToSec(anchor, section) {
	var $thisAnchor = $(anchor);
	var $thisSection = $(section);
	$thisAnchor.find('a').click(function(e) {
		e.preventDefault();
		$thisAnchor.find('a').parent().removeClass('active')
		$(this).parent().addClass('active');
		var targetSection = $(this).attr('href').split('#')[1];
		var sectionPos = $thisSection.find('[data-link="'+targetSection+'"]').offset().top;
		moveTo(sectionPos);
	})
}
function moveTo(position) {
	var headerHeight = $('.c-sticky-header').outerHeight();
	$("html, body").animate({ 
		scrollTop: position - headerHeight
	}, "slow");
}
function addScreenheight() {
	var nextSecShow = 150;
	if(winHeight<768){
		nextSecShow = 200;
	}
	$(".c-event-banner").css({
		'minHeight': winHeight - nextSecShow,
		'paddingTop': headerHeight + 30,
		'marginTop': -headerHeight,

	});
	if (winWidth > 1199) {
		$(".c-event-list").css({
			'minHeight': winHeight,
		});
	} else {
		$(".c-event-list").removeAttr('style');

	}
}
function maxHeightSelectors() {
	maxHeightContent('.c-thumbnailBox .thumbContent .content:not(.fullwidth .thumbContent .content, .c--style2.c--horizontal .thumbContent .content) h3');
	maxHeightContent('.c-thumbnailBox .thumbContent .content:not(.fullwidth .thumbContent .content, .c--style2.c--horizontal .thumbContent .content) p');
	maxHeightContent('.c-thumbnailBox .thumbContent .eventDetails-wrap');
	maxHeightContent('.c-thumbnailBox .thumbContent .content:not(.fullwidth .thumbContent .content, .c--style2.c--horizontal .thumbContent .content)');
}
function maxHeightContent(ele) {
	var $target = $(ele);
	var heightArr = [];
	$target.css('height', '');
	$target.each(function(i) {
		heightArr[i] = $(this).height();
	});
	var maxHeight = Math.max.apply(this, heightArr);
	$target.height(maxHeight);
}

var browser = function() {
    // Return cached result if avalible, else get result then cache it.
    if (browser.prototype._cachedResult)
        return browser.prototype._cachedResult;

    // Opera 8.0+
    var isOpera = (!!window.opr && !!opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;

    // Firefox 1.0+
    var isFirefox = typeof InstallTrigger !== 'undefined';

    // Safari 3.0+ "[object HTMLElementConstructor]" 
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);

    // Internet Explorer 6-11
    var isIE = /*@cc_on!@*/false || !!document.documentMode;

    // Edge 20+
    var isEdge = !isIE && !!window.StyleMedia;

    // Chrome 1+
    var isChrome = !!window.chrome && !!window.chrome.webstore;

    // Blink engine detection
    var isBlink = (isChrome || isOpera) && !!window.CSS;

    return browser.prototype._cachedResult =
        isOpera ? 'isOpera' :
        isFirefox ? 'isFirefox' :
        isSafari ? 'isSafari' :
        isChrome ? 'isChrome' :
        isIE ? 'isIE' :
        isEdge ? 'isEdge' :
        isBlink ? 'isBlink' :
        "Don't know";

};
$('html').addClass(browser());

$(".form-control").on('focus blur', function(){
	$(this).parents('.control-group').toggleClass('focused');
})

function historyHeight() {
	if ($('.js-timeline-height').length > 0) {
		var marginPageHistory = parseInt($('.page-history').css('margin-top').split('px')[0]);
		var marginTimeline = parseInt($('.js-timeline-height').css('margin-top').split('px')[0]);
		var workingHeight = winHeight - headerHeight - marginTimeline - marginPageHistory - 24;
		$('.js-timeline-height').css('height', workingHeight);
	}
}
function fixedToScroll() {
	if ($('.js-fixed-sidebar').length > 0) {
		$('.js-fixed-sidebar').css('width', $('.js-fixed-sidebar').parent().width())
		var footerOffset = $('.c-main-footer').offset().top;
		var scrollOffset = $('.js-fixed-sidebar').offset().top;
		var sidebarHeight = $('.js-fixed-sidebar').outerHeight();
		var forFixedOffset = scrollOffset - headerHeight + 26;
		var forBottomOffset = footerOffset - 70 - sidebarHeight - headerHeight;
		$(window).scroll(function() {
			var winScroll = $(this).scrollTop();
			if (winScroll > forFixedOffset) {
				$('.js-fixed-sidebar').addClass('is--fixed');
				$('.js-fixed-sidebar').removeClass('is--bottom');
				if (winScroll > forBottomOffset){
					$('.js-fixed-sidebar').addClass('is--bottom');
				} 
			} else{
				$('.js-fixed-sidebar').removeClass('is--fixed is--bottom');
			}
		});
	}
}
function elementInViewport2(el) {
	var top = el.offsetTop;
	var left = el.offsetLeft;
	var width = el.offsetWidth;
	var height = el.offsetHeight;

	while (el.offsetParent) {
		el = el.offsetParent;
		top += el.offsetTop;
		left += el.offsetLeft;
	}

	return (
		top < (window.pageYOffset + window.innerHeight) &&
		left < (window.pageXOffset + window.innerWidth) &&
		(top + height) > window.pageYOffset &&
		(left + width) > window.pageXOffset
	);
}

var scroll = function (rush) {
	$('[data-link]').each(function () {
		var sdx = $(this).position().top;
		var wx = $(window).scrollTop();
		var dp = winHeight / 2;
		var dds = $(this).position().top - $(window).scrollTop();
	   	if (elementInViewport2(this)) {
	     	var thisValue = $(this).attr('data-link');
	    	if (dds < dp) {
	        	$('.js-scroll-anchor li').removeClass('active');
	     		$('.js-scroll-anchor a[href="#'+thisValue+'"]').parent().addClass('active')
		    }
		}
	});
};

var waiting = false,
	endScrollHandle;
$(window).scroll(function () {
	if (waiting) {
		return;
	}
	waiting = true;

	// clear previous scheduled endScrollHandle
	clearTimeout(endScrollHandle);

	scroll('dontRush');

	setTimeout(function () {
		waiting = false;
	}, 100);

	// schedule an extra execution of scroll() after 200ms
	// in case the scrolling stops in next 100ms
	endScrollHandle = setTimeout(function () {
		scroll();
	}, 200);
});

var $thislink;

createlinksInstance();

function createlinksInstance() {
	$('.c-main-header .secondary-nav>ul>li a:not(.dom-updated)').each(function () {
		var $thislink = $(this);
		if(!$($thislink).parent().hasClass('hamburger')) {
			$($thislink).wrapInner( "<span><i></i></span>" );
			var thisSpan = $thislink.html();
			var i;
			for (i = 0; i < 2; i++) {
				$($thislink).append(thisSpan);
			}
			$($thislink).addClass('dom-updated');
		}
	})
}
function dataTrim() {
	var ellipsis = "...";
	$('[data-trim]').each(function(){
		if(!$(this).hasClass('is--trimmed')){
			var text = $(this).html();
			var charLimit = parseInt($(this).attr('data-trim'));
			$(this).html(TrimLength(text, charLimit));
			$(this).addClass('is--trimmed');
		}
	});
	function TrimLength(text, maxLength){
	    text = $.trim(text);
	    if (text.length > maxLength) {
	        text = text.substring(0, maxLength - ellipsis.length)
	        return text.substring(0, text.lastIndexOf(" ")) + ellipsis;
	    }
	    else return text;
	}
}
function delayAutoPlay(slickItem) {
	$(slickItem).slick('slickPause');
	setTimeout(function () {
		$(slickItem).slick('slickPlay');
	}, 2000);
}
function addThisReadyBind() {
	var socialBindInterval = setInterval(function () {
		if($('#at4-scc').get(0)){
			clearInterval(socialBindInterval);
			$('#at4-scc').click(function () {
				$('.addthis-smartlayers').addClass('is--closed');
			});
			$('#at4-soc').click(function () {
				$('.addthis-smartlayers').removeClass('is--closed');
			});
		}
	}, 500);
}
function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

var config = {
    key: 'sitecore:@lhosn@p!K3y'
}

function GetKey() {
    return btoa(config.key);
}

$(function () {
    $(".sc_form_submit").click(function () {
        $(this).parents("form").trigger("submit");
        $(".field-validation-error").css("color", "red");
        var errorcount = $(".field-validation-error").length;

        if (errorcount == 0) {
            $(this).parent().addClass("isloading");
        }
    });
});